import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MultiSelect from '../../common/Forms/MultiSelect';

const RailsMultiSelect = ({ options, selectedValues, inputName, placeholder, isFullWidth }) => {
  const [selectedOptions, setSelectedOptions] = useState(selectedValues);

  const handleChange = (options) => {
    setSelectedOptions(options);
  };

  const containerStyle = {
    width: isFullWidth ? '100%' : '500px'
  }

  return (
    <div style={containerStyle}>
      <input name={inputName}
             value={selectedOptions.map(option => option.value)}
             hidden/>
      <MultiSelect
        handleChange={handleChange}
        options={options}
        selectedValues={selectedValues}
        placeholderText={placeholder}
      />
    </div>
  );
};

RailsMultiSelect.propTypes = {
  options: PropTypes.array,
  selectedValues: PropTypes.array
};

RailsMultiSelect.defaultProps = {
  options: [{}],
  selectedValues: [{}]
};

export default RailsMultiSelect;
